import { render, staticRenderFns } from "./FiltroFrequencia.vue?vue&type=template&id=56270210&"
import script from "./FiltroFrequencia.vue?vue&type=script&lang=js&"
export * from "./FiltroFrequencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports